/* BSN product metafield layout and rotator behavior. */
document.addEventListener('DOMContentLoaded', function () {
  var rotators = document.querySelectorAll('.visit-app-rotator');

  rotators.forEach(function (rotator) {
    var images = Array.prototype.slice.call(
      rotator.querySelectorAll('.visit-app-rotator__image')
    );
    var dots = Array.prototype.slice.call(
      rotator.querySelectorAll('.visit-app-dot')
    );

    if (images.length <= 1) {
      // Nothing to rotate
      return;
    }

    var index = 0;
    var interval =
      parseInt(rotator.getAttribute('data-rotate-interval'), 10) || 4000;
    var timer;

    function showSlide(i) {
      index = (i + images.length) % images.length;

      images.forEach(function (img, idx) {
        img.classList.toggle('is-active', idx === index);
      });

      if (dots.length) {
        dots.forEach(function (dot, idx) {
          dot.classList.toggle('is-active', idx === index);
        });
      }
    }

    function startRotation() {
      stopRotation();
      timer = setInterval(function () {
        showSlide(index + 1);
      }, interval);
    }

    function stopRotation() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    // Initialize
    showSlide(0);
    startRotation();

    // Dot clicks: jump to slide and restart timer
    if (dots.length) {
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var targetIndex = parseInt(dot.getAttribute('data-index'), 10);
          if (!isNaN(targetIndex)) {
            showSlide(targetIndex);
            startRotation();
          }
        });
      });
    }

    // --- Swipe / "flick" support on touch devices ---
    var startX = null;
    var threshold = 25; // how far (px) before we count it as a swipe

    rotator.addEventListener('touchstart', function (e) {
      if (!e.touches || !e.touches.length) return;
      startX = e.touches[0].clientX;
    });

    rotator.addEventListener('touchmove', function (e) {
      if (startX === null || !e.touches || !e.touches.length) return;

      var currentX = e.touches[0].clientX;
      var dx = currentX - startX;

      // Only respond to fairly clear swipes left/right
      if (Math.abs(dx) > threshold) {
        if (dx < 0) {
          // swipe left → next
          showSlide(index + 1);
        } else {
          // swipe right → previous
          showSlide(index - 1);
        }

        startRotation();   // restart timer after manual swipe
        startX = null;     // reset so we don't fire multiple times per swipe
      }
    });

    rotator.addEventListener('touchend', function () {
      startX = null;
    });
  });

  // Vibio slides 2/3/4: mobile heading overlays on image, body content stays below.
  var vibioHeadingConfigs = [
    {
      layoutId: '2',
      productsSelector: '#vibio_products--layout--2',
      overlayClass: 'vibio-mobile-heading-overlay vibio-mobile-heading-overlay--silentwake'
    },
    {
      layoutId: '3',
      productsSelector: '#vibio_products--layout--3',
      overlayClass: 'vibio-mobile-heading-overlay vibio-mobile-heading-overlay--bedfriendly'
    },
    {
      layoutId: '4',
      productsSelector: '#vibio_products--layout--4',
      overlayClass: 'vibio-mobile-heading-overlay vibio-mobile-heading-overlay--snooze'
    }
  ];

  vibioHeadingConfigs.forEach(function (config) {
    var layout = document.querySelector(
      '.overview_layout-vibio-1#ct-overview_layout--' + config.layoutId
    );
    if (!layout) return;

    var imageWrap = layout.querySelector('.vibio-overview_layout--img');
    var products = layout.querySelector(config.productsSelector);
    var textBox = products ? products.querySelector('.custom--contents-text-box') : null;
    var heading = textBox ? textBox.querySelector('h2') : null;
    if (!imageWrap || !products || !textBox || !heading) return;

    var headingMarker = document.createComment(
      'vibio-mobile-heading-marker-' + config.layoutId
    );
    heading.parentNode.insertBefore(headingMarker, heading);

    var overlay = document.createElement('div');
    overlay.className = config.overlayClass;

    function placeVibioHeadingForViewport() {
      if (window.matchMedia('(max-width: 767px)').matches) {
        if (overlay.parentNode !== imageWrap) {
          imageWrap.appendChild(overlay);
        }
        if (heading.parentNode !== overlay) {
          overlay.appendChild(heading);
        }
        return;
      }

      if (headingMarker.parentNode && heading.parentNode !== headingMarker.parentNode) {
        headingMarker.parentNode.insertBefore(heading, headingMarker.nextSibling);
      }
      if (overlay.parentNode) {
        overlay.remove();
      }
    }

    placeVibioHeadingForViewport();
    window.addEventListener('resize', placeVibioHeadingForViewport);
  });

  // App controlled (#5): mobile = header overlay, body text below image, badges below body.
  var appLayout = document.querySelector('#ct-overview_layout--5');
  if (appLayout) {
    var appProducts = appLayout.querySelector('#vibio_products--layout--5');
    var appTextBox = appLayout.querySelector('#custom--text-box-5');
    var appHeading = appTextBox ? appTextBox.querySelector('h2') : null;
    var appSubheading = appTextBox ? appTextBox.querySelector('h3') : null;
    var appBadges = appLayout.querySelector('#custom--text-box-5 .ct-vibo-gpay');
    var appImageWrap = appLayout.querySelector('.vibio-overview_layout--img');

    if (appProducts && appTextBox && appHeading && appSubheading && appBadges && appImageWrap) {
      var appProductsMarker = document.createComment('vibio-app-products-marker');
      appProducts.parentNode.insertBefore(appProductsMarker, appProducts);

      var appHeadingMarker = document.createComment('vibio-app-heading-marker');
      var appSubheadingMarker = document.createComment('vibio-app-subheading-marker');
      appHeading.parentNode.insertBefore(appHeadingMarker, appHeading);
      appSubheading.parentNode.insertBefore(appSubheadingMarker, appSubheading);

      var badgeMarker = document.createComment('vibio-app-badges-marker');
      appBadges.parentNode.insertBefore(badgeMarker, appBadges);

      var appOverlay = document.createElement('div');
      appOverlay.className = 'vibio-mobile-title-overlay vibio-mobile-title-overlay--app';
      appOverlay.appendChild(appHeading);
      appOverlay.appendChild(appSubheading);

      var appBodyWrap = document.createElement('div');
      appBodyWrap.className = 'vibio-mobile-body-wrap vibio-mobile-body-wrap--app';

      appBadges.classList.add('vibio-app-badges-row');

      function placeAppBadgesForViewport() {
        if (window.matchMedia('(max-width: 767px)').matches) {
          if (appOverlay.parentNode !== appLayout) {
            appLayout.appendChild(appOverlay);
          }
          if (appBodyWrap.parentNode !== appLayout) {
            appImageWrap.insertAdjacentElement('afterend', appBodyWrap);
          }
          if (appProducts.parentNode !== appBodyWrap) {
            appBodyWrap.appendChild(appProducts);
          }
          if (appBadges.parentNode !== appBodyWrap) {
            appBodyWrap.appendChild(appBadges);
          }
          return;
        }

        if (appProductsMarker.parentNode && appProducts.parentNode !== appProductsMarker.parentNode) {
          appProductsMarker.parentNode.insertBefore(appProducts, appProductsMarker.nextSibling);
        }
        if (appHeadingMarker.parentNode && appHeading.parentNode !== appHeadingMarker.parentNode) {
          appHeadingMarker.parentNode.insertBefore(appHeading, appHeadingMarker.nextSibling);
        }
        if (appSubheadingMarker.parentNode && appSubheading.parentNode !== appSubheadingMarker.parentNode) {
          appSubheadingMarker.parentNode.insertBefore(appSubheading, appSubheadingMarker.nextSibling);
        }
        if (badgeMarker.parentNode && appBadges.parentNode !== badgeMarker.parentNode) {
          badgeMarker.parentNode.insertBefore(appBadges, badgeMarker.nextSibling);
        }
        if (appOverlay.parentNode) {
          appOverlay.remove();
        }
        if (appBodyWrap.parentNode) {
          appBodyWrap.remove();
        }
      }

      placeAppBadgesForViewport();
      window.addEventListener('resize', placeAppBadgesForViewport);
    }
  }

  // Notifications (#6): mobile = header overlay, body text below image, aux image below body.
  var notificationsLayout = document.querySelector('#ct-overview_layout--6');
  if (notificationsLayout) {
    var notificationsText = notificationsLayout.querySelector('#vibio_products--layout--6');
    var notificationsTextBox = notificationsLayout.querySelector('#custom--text-box-6');
    var notificationsHeading = notificationsTextBox ? notificationsTextBox.querySelector('h2') : null;
    var notificationsSubheading = notificationsTextBox ? notificationsTextBox.querySelector('h3') : null;
    var notificationsImageWrap = notificationsLayout.querySelector('.vibio-overview_layout--img');
    var inlineNotificationImage = notificationsLayout.querySelector('#custom--text-box-6 p img');
    var inlineNotificationImageRow = inlineNotificationImage ? inlineNotificationImage.closest('p') : null;

    if (notificationsText && notificationsTextBox && notificationsHeading && notificationsSubheading && notificationsImageWrap && inlineNotificationImageRow) {
      var notificationsTextMarker = document.createComment('vibio-notifications-text-marker');
      notificationsText.parentNode.insertBefore(notificationsTextMarker, notificationsText);

      var notificationsHeadingMarker = document.createComment('vibio-notifications-heading-marker');
      var notificationsSubheadingMarker = document.createComment('vibio-notifications-subheading-marker');
      notificationsHeading.parentNode.insertBefore(notificationsHeadingMarker, notificationsHeading);
      notificationsSubheading.parentNode.insertBefore(notificationsSubheadingMarker, notificationsSubheading);

      var notificationsMarker = document.createComment('vibio-notifications-image-marker');
      inlineNotificationImageRow.parentNode.insertBefore(notificationsMarker, inlineNotificationImageRow);

      var notificationsOverlay = document.createElement('div');
      notificationsOverlay.className = 'vibio-mobile-title-overlay vibio-mobile-title-overlay--notifications';
      notificationsOverlay.appendChild(notificationsHeading);
      notificationsOverlay.appendChild(notificationsSubheading);

      var notificationsBodyWrap = document.createElement('div');
      notificationsBodyWrap.className = 'vibio-mobile-body-wrap vibio-mobile-body-wrap--notifications';

      inlineNotificationImageRow.classList.add('vibio-notification-inline-image');

      function placeNotificationsInlineImageForViewport() {
        if (window.matchMedia('(max-width: 767px)').matches) {
          if (notificationsOverlay.parentNode !== notificationsLayout) {
            notificationsLayout.appendChild(notificationsOverlay);
          }
          if (notificationsBodyWrap.parentNode !== notificationsLayout) {
            notificationsImageWrap.insertAdjacentElement('afterend', notificationsBodyWrap);
          }
          if (notificationsText.parentNode !== notificationsBodyWrap) {
            notificationsBodyWrap.appendChild(notificationsText);
          }
          if (inlineNotificationImageRow.parentNode !== notificationsBodyWrap) {
            notificationsBodyWrap.appendChild(inlineNotificationImageRow);
          }
          return;
        }

        if (notificationsTextMarker.parentNode && notificationsText.parentNode !== notificationsTextMarker.parentNode) {
          notificationsTextMarker.parentNode.insertBefore(notificationsText, notificationsTextMarker.nextSibling);
        }
        if (notificationsHeadingMarker.parentNode && notificationsHeading.parentNode !== notificationsHeadingMarker.parentNode) {
          notificationsHeadingMarker.parentNode.insertBefore(notificationsHeading, notificationsHeadingMarker.nextSibling);
        }
        if (notificationsSubheadingMarker.parentNode && notificationsSubheading.parentNode !== notificationsSubheadingMarker.parentNode) {
          notificationsSubheadingMarker.parentNode.insertBefore(notificationsSubheading, notificationsSubheadingMarker.nextSibling);
        }
        if (notificationsMarker.parentNode && inlineNotificationImageRow.parentNode !== notificationsMarker.parentNode) {
          notificationsMarker.parentNode.insertBefore(inlineNotificationImageRow, notificationsMarker.nextSibling);
        }
        if (notificationsOverlay.parentNode) {
          notificationsOverlay.remove();
        }
        if (notificationsBodyWrap.parentNode) {
          notificationsBodyWrap.remove();
        }
      }

      placeNotificationsInlineImageForViewport();
      window.addEventListener('resize', placeNotificationsInlineImageForViewport);
    }
  }

  // Mino slides: per-slide mobile heading overlays + optional body panels below image.
  var minoConfigs = [
    {
      layoutId: '1',
      overlaySource: '#mino__products--layout--1',
      overlaySelectors: ['h1', 'h2', 'p'],
      overlayClass: 'mino-overlay-left-center',
      bodySource: null
    },
    {
      layoutId: '2',
      overlaySource: '#mino__products--layout--2',
      overlaySelectors: ['h2'],
      overlayClass: 'mino-overlay-center-center',
      bodySource: '#mino__products--layout--2'
    },
    {
      layoutId: '3',
      overlaySource: '#mino__products--layout--3',
      overlaySelectors: ['h2'],
      overlayClass: 'mino-overlay-top-right-raised',
      bodySource: '#mino__products--layout--32'
    },
    {
      layoutId: '4',
      overlaySource: '#mino__products--layout--4',
      overlaySelectors: ['h2'],
      overlayClass: 'mino-overlay-center-right',
      bodySource: '#mino__products--layout--4'
    },
    {
      layoutId: '5',
      overlaySource: '#mino__products--layout--5',
      overlaySelectors: ['h2'],
      overlayClass: 'mino-overlay-top-center',
      bodySource: '#mino__products--layout--52'
    },
    {
      layoutId: '6',
      overlaySource: '#mino__products--layout--6',
      overlaySelectors: ['h2'],
      overlayClass: 'mino-overlay-left-center',
      bodySource: '#mino__products--layout--6'
    },
    {
      layoutId: '7',
      overlaySource: '#mino__products--layout--7',
      overlaySelectors: ['h2'],
      overlayClass: 'mino-overlay-left-center',
      bodySource: '#mino__products--layout--7'
    },
    {
      layoutId: '8',
      overlaySource: '#mino__products--layout--8',
      overlaySelectors: ['h2'],
      overlayClass: 'mino-overlay-left-center',
      bodySource: '#mino__products--layout--8'
    },
    {
      layoutId: '9',
      overlaySource: '#mino__products--layout--9',
      overlaySelectors: ['h2'],
      overlayClass: 'mino-overlay-left-top',
      bodySource: null
    },
    {
      layoutId: '10',
      overlaySource: '#mino__products--layout--10',
      overlaySelectors: ['h2'],
      overlayClass: 'mino-overlay-left-center',
      bodySource: '#mino__products--layout--10'
    },
    {
      layoutId: '11',
      overlaySource: '#mino__products--layout--11',
      overlaySelectors: ['h2'],
      overlayClass: 'mino-overlay-left-center',
      bodySource: '#mino__products--layout--11'
    },
    {
      layoutId: '12',
      overlaySource: '#mino__products--layout--12',
      overlaySelectors: ['h2'],
      overlayClass: 'mino-overlay-left-center',
      bodySource: '#mino__products--layout--12'
    },
    {
      layoutId: '13',
      overlaySource: '#mino__products--layout--13',
      overlaySelectors: ['h2'],
      overlayClass: 'mino-overlay-top-center-raised',
      bodySource: null
    },
    {
      layoutId: '15',
      overlaySource: '#mino__products--layout--15',
      overlaySelectors: ['h2'],
      overlayClass: 'mino-overlay-top-center',
      bodySource: '#mino__products--layout--15'
    }
  ];

  minoConfigs.forEach(function (config) {
    var layout = document.querySelector(
      '.overview_layout-mino-1#ct-overview_layout--' + config.layoutId
    );
    if (!layout) return;

    var imageWrap = layout.querySelector('.banner-images.mino-overview_layout--img');
    var overlaySource = layout.querySelector(config.overlaySource);
    if (!imageWrap || !overlaySource) return;

    var overlayTextBox = overlaySource.querySelector('.custom--contents-text-box');
    if (!overlayTextBox) return;

    var overlayNodes = [];
    config.overlaySelectors.forEach(function (selector) {
      var node = overlayTextBox.querySelector(selector);
      if (node) overlayNodes.push(node);
    });
    if (!overlayNodes.length) return;

    var overlayMarkers = overlayNodes.map(function (node, index) {
      var marker = document.createComment('mino-overlay-node-marker-' + config.layoutId + '-' + index);
      node.parentNode.insertBefore(marker, node);
      return marker;
    });

    var overlay = document.createElement('div');
    overlay.className = 'mino-mobile-overlay ' + config.overlayClass;

    var bodySource = config.bodySource ? layout.querySelector(config.bodySource) : null;
    var hideOverlaySourceOnMobile =
      !!bodySource && config.bodySource !== config.overlaySource;
    var bodyMarker = null;
    var bodyWrap = null;

    if (bodySource) {
      bodyMarker = document.createComment('mino-body-marker-' + config.layoutId);
      bodySource.parentNode.insertBefore(bodyMarker, bodySource);
      bodyWrap = document.createElement('div');
      bodyWrap.className = 'mino-mobile-body-wrap mino-mobile-body-wrap--' + config.layoutId;
    }

    function placeMinoForViewport() {
      if (window.matchMedia('(max-width: 767px)').matches) {
        if (overlay.parentNode !== imageWrap) {
          imageWrap.appendChild(overlay);
        }

        overlayNodes.forEach(function (node) {
          if (node.parentNode !== overlay) {
            overlay.appendChild(node);
          }
        });

        if (hideOverlaySourceOnMobile) {
          overlaySource.style.display = 'none';
        }

        if (bodySource && bodyWrap) {
          if (bodyWrap.parentNode !== layout) {
            imageWrap.insertAdjacentElement('afterend', bodyWrap);
          }
          if (bodySource.parentNode !== bodyWrap) {
            bodyWrap.appendChild(bodySource);
          }
        }

        return;
      }

      overlayNodes.forEach(function (node, index) {
        var marker = overlayMarkers[index];
        if (marker.parentNode && node.parentNode !== marker.parentNode) {
          marker.parentNode.insertBefore(node, marker.nextSibling);
        }
      });

      if (overlay.parentNode) {
        overlay.remove();
      }

      if (hideOverlaySourceOnMobile) {
        overlaySource.style.display = '';
      }

      if (bodySource && bodyMarker && bodyMarker.parentNode && bodySource.parentNode !== bodyMarker.parentNode) {
        bodyMarker.parentNode.insertBefore(bodySource, bodyMarker.nextSibling);
      }
      if (bodyWrap && bodyWrap.parentNode) {
        bodyWrap.remove();
      }
    }

    placeMinoForViewport();
    window.addEventListener('resize', placeMinoForViewport);
  });

  // Domino slides: mobile heading overlays + optional gradient body panels.
  var dominoConfigs = [
    {
      layoutId: '1',
      overlaySource: '#domino__products--layout--1',
      overlayClass: 'domino-overlay-top-center',
      bodySource: null
    },
    {
      layoutId: '2',
      overlaySource: '#domino__products--layout--2',
      overlayClass: 'domino-overlay-center-left',
      bodySource: '#domino__products--layout--2'
    },
    {
      layoutId: '3',
      overlaySource: '#domino__products--layout--3',
      overlayClass: 'domino-overlay-center-left',
      bodySource: '#domino__products--layout--3'
    },
    {
      layoutId: '4',
      overlaySource: '#domino__products--layout--4',
      overlayClass: 'domino-overlay-center-left',
      bodySource: '#domino__products--layout--4'
    },
    {
      layoutId: '5',
      overlaySource: '#domino__products--layout--5',
      overlayClass: 'domino-overlay-center-left',
      bodySource: '#domino__products--layout--5'
    },
    {
      layoutId: '6',
      overlaySource: '#domino__products--layout--6',
      overlayClass: 'domino-overlay-top-left',
      bodySource: null
    },
    {
      layoutId: '7',
      overlaySource: '#domino__products--layout--7',
      overlayClass: 'domino-overlay-top-left',
      bodySource: '#domino__products--layout--7'
    },
    {
      layoutId: '8',
      overlaySource: '#domino__products--layout--8',
      overlayClass: 'domino-overlay-center-left',
      bodySource: '#domino__products--layout--8'
    },
    {
      layoutId: '11',
      overlaySource: '#domino__products--layout--11',
      overlayClass: 'domino-overlay-top-center',
      bodySource: null
    }
  ];

  dominoConfigs.forEach(function (config) {
    var layout = document.querySelector(
      '.overview_layout-domino-1#ct-overview_layout--' + config.layoutId
    );
    if (!layout) return;

    var imageWrap = layout.querySelector('.banner-images.domino-overview_layout--img');
    var overlaySource = layout.querySelector(config.overlaySource);
    if (!imageWrap || !overlaySource) return;

    var overlayTextBox = overlaySource.querySelector('.custom--contents-text-box');
    var overlayNode = overlayTextBox ? overlayTextBox.querySelector('h2') : null;
    if (!overlayNode) return;

    var overlayMarker = document.createComment('domino-overlay-node-marker-' + config.layoutId);
    overlayNode.parentNode.insertBefore(overlayMarker, overlayNode);

    var overlay = document.createElement('div');
    overlay.className = 'domino-mobile-overlay ' + config.overlayClass;

    var bodySource = config.bodySource ? layout.querySelector(config.bodySource) : null;
    var bodyMarker = null;
    var bodyWrap = null;
    var hideOverlaySourceOnMobile =
      !bodySource || config.bodySource !== config.overlaySource;

    if (bodySource) {
      bodyMarker = document.createComment('domino-body-marker-' + config.layoutId);
      bodySource.parentNode.insertBefore(bodyMarker, bodySource);
      bodyWrap = document.createElement('div');
      bodyWrap.className =
        'domino-mobile-body-wrap domino-mobile-body-wrap--' + config.layoutId;
    }

    function placeDominoForViewport() {
      if (window.matchMedia('(max-width: 767px)').matches) {
        if (overlay.parentNode !== imageWrap) {
          imageWrap.appendChild(overlay);
        }
        if (overlayNode.parentNode !== overlay) {
          overlay.appendChild(overlayNode);
        }
        if (hideOverlaySourceOnMobile) {
          overlaySource.style.display = 'none';
        }

        if (bodySource && bodyWrap) {
          if (bodyWrap.parentNode !== layout) {
            imageWrap.insertAdjacentElement('afterend', bodyWrap);
          }
          if (bodySource.parentNode !== bodyWrap) {
            bodyWrap.appendChild(bodySource);
          }
        }
        return;
      }

      if (overlayMarker.parentNode && overlayNode.parentNode !== overlayMarker.parentNode) {
        overlayMarker.parentNode.insertBefore(overlayNode, overlayMarker.nextSibling);
      }
      if (overlay.parentNode) {
        overlay.remove();
      }

      if (hideOverlaySourceOnMobile) {
        overlaySource.style.display = '';
      }

      if (bodySource && bodyMarker && bodyMarker.parentNode && bodySource.parentNode !== bodyMarker.parentNode) {
        bodyMarker.parentNode.insertBefore(bodySource, bodyMarker.nextSibling);
      }
      if (bodyWrap && bodyWrap.parentNode) {
        bodyWrap.remove();
      }
    }

    placeDominoForViewport();
    window.addEventListener('resize', placeDominoForViewport);
  });

  // Response with earbuds slides: mobile heading overlays + body panels.
  var responseConfigs = [
    {
      layoutId: '1',
      source: '#ct_products--layout--1',
      overlaySelector: 'h1',
      overlayClass: 'response-overlay-center-left'
    },
    {
      layoutId: '2',
      source: '#ct_products--layout--2',
      overlaySelector: 'h1',
      overlayClass: 'response-overlay-center-left'
    },
    {
      layoutId: '3',
      source: '#ct_products--layout--3',
      overlaySelector: 'h1',
      overlayClass: 'response-overlay-center-left'
    }
  ];

  responseConfigs.forEach(function (config) {
    var layouts = document.querySelectorAll(
      '.mr_bottom_ten.overview_layout--1#ct-overview_layout--' + config.layoutId
    );

    layouts.forEach(function (layout) {
      var imageWrap = layout.querySelector('.banner-images.ct-overview_layout--img');
      var bodySource = layout.querySelector(config.source);
      if (!imageWrap || !bodySource || !bodySource.classList.contains('responsewithearbuds')) {
        return;
      }

      var textBox = bodySource.querySelector('.custom--contents-text-box');
      var overlayNode = textBox ? textBox.querySelector(config.overlaySelector) : null;
      if (!textBox || !overlayNode) return;

      var overlayMarker = document.createComment(
        'response-overlay-node-marker-' + config.layoutId
      );
      overlayNode.parentNode.insertBefore(overlayMarker, overlayNode);

      var bodyMarker = document.createComment(
        'response-body-marker-' + config.layoutId
      );
      bodySource.parentNode.insertBefore(bodyMarker, bodySource);

      var overlay = document.createElement('div');
      overlay.className = 'response-mobile-overlay ' + config.overlayClass;

      var bodyWrap = document.createElement('div');
      bodyWrap.className = 'response-mobile-body-wrap response-mobile-body-wrap--' + config.layoutId;

      function placeResponseForViewport() {
        if (window.matchMedia('(max-width: 768px)').matches) {
          if (overlay.parentNode !== imageWrap) {
            imageWrap.appendChild(overlay);
          }
          if (overlayNode.parentNode !== overlay) {
            overlay.appendChild(overlayNode);
          }
          if (bodyWrap.parentNode !== layout) {
            imageWrap.insertAdjacentElement('afterend', bodyWrap);
          }
          if (bodySource.parentNode !== bodyWrap) {
            bodyWrap.appendChild(bodySource);
          }
          return;
        }

        if (overlayMarker.parentNode && overlayNode.parentNode !== overlayMarker.parentNode) {
          overlayMarker.parentNode.insertBefore(overlayNode, overlayMarker.nextSibling);
        }
        if (bodyMarker.parentNode && bodySource.parentNode !== bodyMarker.parentNode) {
          bodyMarker.parentNode.insertBefore(bodySource, bodyMarker.nextSibling);
        }
        if (overlay.parentNode) {
          overlay.remove();
        }
        if (bodyWrap.parentNode) {
          bodyWrap.remove();
        }
      }

      placeResponseForViewport();
      window.addEventListener('resize', placeResponseForViewport);
    });
  });

  // Alarm slides: mobile heading overlays + body panels.
  var alarmConfigs = [
    {
      layoutId: '1',
      overlaySource: '#alarm_products--layout--1',
      overlayClass: 'alarm-overlay-center-right',
      bodySource: null
    },
    {
      layoutId: '2',
      overlaySource: '#alarm_products--layout--2',
      overlayClass: 'alarm-overlay-center-left',
      bodySource: '#alarm_products--layout--2'
    },
    {
      layoutId: '3',
      overlaySource: '#alarm_products--layout--3',
      overlayClass: 'alarm-overlay-top-left',
      bodySource: '#alarm_products--layout--3'
    },
    {
      layoutId: '4',
      overlaySource: '#alarm_products--layout--3',
      overlayClass: 'alarm-overlay-center-left',
      bodySource: '#alarm_products--layout--3'
    },
    {
      layoutId: '5',
      overlaySource: '#alarm_products--layout--3',
      overlayClass: 'alarm-overlay-center-left',
      bodySource: '#alarm_products--layout--3'
    },
    {
      layoutId: '6',
      overlaySource: '#alarm_products--layout--3',
      overlayClass: 'alarm-overlay-center-left',
      bodySource: '#alarm_products--layout--3'
    },
    {
      layoutId: '7',
      overlaySource: '#alarm_products--layout--3',
      overlayClass: 'alarm-overlay-center-left',
      bodySource: '#alarm_products--layout--3'
    },
    {
      layoutId: '8',
      overlaySource: '#alarm_products--layout--8',
      overlayClass: 'alarm-overlay-top-center',
      bodySource: null
    }
  ];

  alarmConfigs.forEach(function (config) {
    var layout = document.querySelector(
      '.overview_layout-alarm-1#ct-overview_layout--' + config.layoutId
    );
    if (!layout) return;

    var imageWrap = layout.querySelector('.banner-images.vibio-overview_layout--img');
    var overlaySource = layout.querySelector(config.overlaySource);
    if (!imageWrap || !overlaySource) return;

    var overlayTextBox = overlaySource.querySelector('.custom--contents-text-box');
    var overlayNode = overlayTextBox ? overlayTextBox.querySelector('h1') : null;
    if (!overlayNode) return;

    var overlayMarker = document.createComment('alarm-overlay-node-marker-' + config.layoutId);
    overlayNode.parentNode.insertBefore(overlayMarker, overlayNode);

    var overlay = document.createElement('div');
    overlay.className = 'alarm-mobile-overlay ' + config.overlayClass;

    var bodySource = config.bodySource ? layout.querySelector(config.bodySource) : null;
    var bodyMarker = null;
    var bodyWrap = null;
    var hideOverlaySourceOnMobile =
      !bodySource || config.bodySource !== config.overlaySource;

    if (bodySource) {
      bodyMarker = document.createComment('alarm-body-marker-' + config.layoutId);
      bodySource.parentNode.insertBefore(bodyMarker, bodySource);
      bodyWrap = document.createElement('div');
      bodyWrap.className = 'alarm-mobile-body-wrap alarm-mobile-body-wrap--' + config.layoutId;
    }

    function placeAlarmForViewport() {
      if (window.matchMedia('(max-width: 768px)').matches) {
        if (overlay.parentNode !== imageWrap) {
          imageWrap.appendChild(overlay);
        }
        if (overlayNode.parentNode !== overlay) {
          overlay.appendChild(overlayNode);
        }
        if (hideOverlaySourceOnMobile) {
          overlaySource.style.display = 'none';
        }

        if (bodySource && bodyWrap) {
          if (bodyWrap.parentNode !== layout) {
            imageWrap.insertAdjacentElement('afterend', bodyWrap);
          }
          if (bodySource.parentNode !== bodyWrap) {
            bodyWrap.appendChild(bodySource);
          }
        }
        return;
      }

      if (overlayMarker.parentNode && overlayNode.parentNode !== overlayMarker.parentNode) {
        overlayMarker.parentNode.insertBefore(overlayNode, overlayMarker.nextSibling);
      }
      if (overlay.parentNode) {
        overlay.remove();
      }

      if (hideOverlaySourceOnMobile) {
        overlaySource.style.display = '';
      }

      if (bodySource && bodyMarker && bodyMarker.parentNode && bodySource.parentNode !== bodyMarker.parentNode) {
        bodyMarker.parentNode.insertBefore(bodySource, bodyMarker.nextSibling);
      }
      if (bodyWrap && bodyWrap.parentNode) {
        bodyWrap.remove();
      }
    }

    placeAlarmForViewport();
    window.addEventListener('resize', placeAlarmForViewport);
  });

  // Maxi Pro feature slides: on mobile split bullets into a panel below the image.
  var maxiFeatureSlides = document.querySelectorAll(
    '.maxipronecklooptvstreamer#grid-products--layout-2'
  );

  maxiFeatureSlides.forEach(function (slide) {
    var bulletList = slide.querySelector('ul.list-style-red');
    if (!bulletList) return;

    slide.classList.add('maxi-pro-feature-slide');

    var overview = slide.closest('.overview_layout--1.overview_layout--nm');
    if (!overview) return;
    overview.classList.add('maxi-pro-feature-parent');

    var imageWrap = overview.querySelector('.banner-images.overview_layout--img');
    if (!imageWrap) return;

    var slideMarker = document.createComment('maxi-pro-slide-marker');
    slide.parentNode.insertBefore(slideMarker, slide);

    var listMarker = document.createComment('maxi-pro-bullets-marker');
    bulletList.parentNode.insertBefore(listMarker, bulletList);

    var bulletsPanel = document.createElement('div');
    bulletsPanel.className = 'maxi-pro-bullets-panel';
    bulletsPanel.appendChild(bulletList);

    function placeMaxiBulletsForViewport() {
      if (window.matchMedia('(max-width: 767px)').matches) {
        if (slide.parentNode !== imageWrap) {
          imageWrap.appendChild(slide);
        }
        if (bulletsPanel.parentNode !== overview) {
          imageWrap.insertAdjacentElement('afterend', bulletsPanel);
        }
        return;
      }

      if (slideMarker.parentNode && slide.parentNode !== slideMarker.parentNode) {
        slideMarker.parentNode.insertBefore(slide, slideMarker.nextSibling);
      }
      if (listMarker.parentNode && bulletList.parentNode !== listMarker.parentNode) {
        listMarker.parentNode.insertBefore(bulletList, listMarker.nextSibling);
      }
      if (bulletsPanel.parentNode) {
        bulletsPanel.remove();
      }
    }

    placeMaxiBulletsForViewport();
    window.addEventListener('resize', placeMaxiBulletsForViewport);
  });

  // Good ergonomics slide: move heading + subheading to image overlay on mobile.
  var goodErgonomicsSlide = document.querySelector(
    '.overview_layout--nm .maxipronecklooptvstreamer.good_ergonomics'
  );

  if (goodErgonomicsSlide) {
    var goodOverview = goodErgonomicsSlide.closest('.overview_layout--nm');
    var goodImageWrap = goodOverview ? goodOverview.querySelector('.banner-images.overview_layout--img') : null;
    var goodTextBox = goodErgonomicsSlide.querySelector('#custom--text-box-2');
    var goodHeading = goodTextBox ? goodTextBox.querySelector('h2') : null;
    var goodSubheading = goodTextBox ? goodTextBox.querySelector('p') : null;

    if (goodOverview && goodImageWrap && goodTextBox && goodHeading && goodSubheading) {
      goodOverview.classList.add('maxi-good-ergonomics-slide');

      var goodHeadingMarker = document.createComment('maxi-good-heading-marker');
      var goodSubheadingMarker = document.createComment('maxi-good-subheading-marker');
      goodTextBox.insertBefore(goodHeadingMarker, goodHeading);
      goodTextBox.insertBefore(goodSubheadingMarker, goodSubheading);

      var goodOverlay = document.createElement('div');
      goodOverlay.className = 'maxi-good-ergonomics-overlay';
      goodOverlay.appendChild(goodHeading);
      goodOverlay.appendChild(goodSubheading);

      function placeGoodErgonomicsForViewport() {
        if (window.matchMedia('(max-width: 767px)').matches) {
          if (goodOverlay.parentNode !== goodOverview) {
            goodImageWrap.insertAdjacentElement('afterend', goodOverlay);
          }
          return;
        }

        if (goodHeadingMarker.parentNode && goodHeading.parentNode !== goodHeadingMarker.parentNode) {
          goodHeadingMarker.parentNode.insertBefore(goodHeading, goodHeadingMarker.nextSibling);
        }
        if (goodSubheadingMarker.parentNode && goodSubheading.parentNode !== goodSubheadingMarker.parentNode) {
          goodSubheadingMarker.parentNode.insertBefore(goodSubheading, goodSubheadingMarker.nextSibling);
        }
        if (goodOverlay.parentNode) {
          goodOverlay.remove();
        }
      }

      placeGoodErgonomicsForViewport();
      window.addEventListener('resize', placeGoodErgonomicsForViewport);
    }
  }
});
